import React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { createAboutTableInfoLabel } from "./SiteAboutPageUtils/createAboutTableInfoLabel";
export const AboutTableHead = ({
  titlesArray,
  cellWidth,
}: {
  titlesArray: string[];
  cellWidth?: string;
}) => {
  return (
    <TableHead>
      <TableRow>
        {titlesArray.map((title: string, index: number) => {
          if (title === "Armed" || title === "Synced" || title === "Motion %") {
            return (
              <React.Fragment key={`${title}-${index}`}>
                {createAboutTableInfoLabel(title)}
              </React.Fragment>
            );
          } else {
            return (
              <TableCell
                key={`${title}-${index}`}
                align="left"
                sx={{
                  fontFamily: "Mulish",
                  fontWeight: "Bold",
                  ...(cellWidth ? { width: cellWidth } : {}),
                }}
              >
                {title}
              </TableCell>
            );
          }
        })}
      </TableRow>
    </TableHead>
  );
};
